import fetch from '@/utils/fetch';
import { message } from 'antd';

const model = {
  state: {
    detail: {},
    merchantList: [],
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { shopBrand }, getState }) => ({
    async move(brandId, step) {
      const result = await fetch('/saasmerchant/web/fsbrand/move', {
        type: 'POST',
        params: {
          brandId,
          step,
        },
        useJson: true,
      });
      if (result) {
        message.success('移动成功');
      }
      return result;
    },
    async setStatus(brandId, status) {
      const result = await fetch('/saasmerchant/web/fsbrand/setStatus', {
        type: 'POST',
        params: {
          brandId,
          status,
        },
        useJson: true,
      });
      if (result) {
        message.success('状态更新成功');
      }
      return result;
    },
    async addBrand(params, history) {
      const result = await fetch('/saasmerchant/web/fsbrand/add', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (result) {
        message.success('创建成功');
        history.push('/merchant/brand');
      }
    },
    async getDetail(params) {
      const data = await fetch('/saasmerchant/web/fsbrand/detailBrand', { params });
      if (data) {
        shopBrand.setState({ detail: data });
      }
      return data;
    },
    clearDetail() {
      shopBrand.setState({ detail: {} });
    },
    async updateBrand(params, history) {
      const result = await fetch('/saasmerchant/web/fsbrand/updateBrand', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (result) {
        message.success('修改成功');
        history.push('/merchant/brand');
      }
    },
    // 获取商户下拉列表
    async getMerchantList(params) {
      const data = await fetch('/saasmerchant/web/fsbrand/getAssociateMerchantList', {
        params,
      });
      data && shopBrand.setState({ merchantList: data });
    },
    // 绑定商户
    async bindMerchant(params) {
      const data = await fetch('/saasmerchant/web/fsbrand/associateMerchant', {
        type: 'POST',
        useJson: true,
        params: {
          merchantIds: params.merchantIds,
          brandId: params.brandId,
        },
      });
      data && message.success('绑定成功');
    },
    // 充值密码
    async onResetPassWord(brandId) {
      const data = await fetch('/saasmerchant/web/fsbrand/resetPassword', {
        params: {
          brandId,
        },
      });
      return data;
    },
    async getBrandOfMerchantList(brandId) {
      const data = await fetch('/saasmerchant/web/fsbrand/getMerchantListOfBrand', {
        params: {
          brandId,
        },
      });
      data && shopBrand.setState({ merchantList: data });
      return data;
    },
  }),
};

export default model;
